import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ArticleTable from '@accounting/components/tables/article-table/article-table.vue';

@Component({
  name: 'bpc-articles',
  components: {
    'bpc-article-table': ArticleTable,
  },
})
export default class Articles extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
